import { inject, Injectable } from '@angular/core';
import { AppLanguageService } from '@app/services/app-language.service';
import { AppStorageService } from '@app/services/app-storage.service';
import { AwsAmplifyService } from '@app/services/aws-amplify.service';
import { UserService } from '@app/services/user.service';
import { STORAGE_SSO } from '@app/utils/constants';
import { environment } from '@env/environment';
import { KuiThemeService } from '@kone/ui';

@Injectable({
    providedIn: 'root',
})
export class AppStarterService {
    private themeService = inject(KuiThemeService);
    private appLanguageService = inject(AppLanguageService);
    private userService = inject(UserService);
    private awsAmplifyService = inject(AwsAmplifyService);
    private appStorageService = inject(AppStorageService);

    async initServices(): Promise<boolean> {
        const previousTheme = this.appStorageService.getItem(
            environment.localStorageName + '_theme',
        );
        this.themeService.init(
            previousTheme === 'dark' || previousTheme === 'light' ? previousTheme : undefined,
        );
        this.appLanguageService.fnInit();

        const valid = await this.awsAmplifyService.getToken();

        if (!valid) return false;

        const response = await this.userService.setUserData();

        if (response.value) {
            const isFromSSO: boolean = this.appStorageService.getItem(STORAGE_SSO) ?? false;
            this.userService.store.updateItem({
                isLoggedIn: !isFromSSO,
                redirectToLanding: isFromSSO,
            });
        }

        return !response.value; // hasError
    }
}
